import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { ASSETS_BASE_URL } from "../../../config/constants";
import { formatProjectDate } from "../../../controllers/common";
import moment from "moment";
const OrderDetails = () => {
  const location = useLocation();
  const state = location.state.item;
  const [orderData, setOrderData] = useState(state ?? []);
  const navigate = useNavigate();
  console.log(orderData, "orderData");
  return (
    <div>
      <div className="container-fluid">
        <div className="orders_main_contaniner">
          <div>
            <nav className="navbar navbar-light justify-content-between w-100 navbar_content">
              <Link to="/order/list" className="navbar-brand common_inventory_heading">
                Order Details
              </Link>
              <Link to="/product/order/list">
                <button type="button" className="btn btn-secondary">
                  <ArrowLeftOutlined /> Back
                </button>
              </Link>
            </nav>
          </div>

          {/* Order Summary Section */}
          <div className="order_now_card_title">
          </div>
          <div className="row mt-4">
            <div className="col-lg-8">
              <div className="card mb-4">
                <div className="card-body">
                  <p><strong>Order Number:</strong> {orderData?.order_no}</p>
                  <p><strong>Status:</strong> {orderData?.status}</p>
                  <p><strong>Order Date:</strong> {formatProjectDate(orderData?.createdAt)}</p>
                  <p><strong>Quantity:</strong> {orderData?.qty}</p>
                  <p><strong>Rate:</strong> {orderData?.rate}</p>
                  <p><strong>Order Type:</strong> {orderData?.isDelivery === 'Y'?'Delivery':'Pickup'}</p>
                  <p><strong>Delivery Status:</strong> {orderData?.deliveryStatus}</p>
                </div>
              </div>

              {/* Product Details Section */}
              <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">
                    Product Details
                  </span>
                  <div className="product-details">
                    <img
                      src={`${ASSETS_BASE_URL}${orderData?.product_id?.image}`}
                      alt={orderData?.product_id?.name}
                      width='100px'
                      className="product-image"
                    />
                    <p><strong>Product Name:</strong> {orderData?.product_id?.name}</p>
                    <p><strong>Description:</strong> {orderData?.product_id?.description}</p>
                    <p><strong>Variant:</strong> {orderData?.variant_id?.unit}</p>
                    <p><strong>Price:</strong> {orderData?.variant_id?.price}</p>
                  </div>
                </div>
              </div>

              {/* Voucher Details Section */}
              <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">
                    Voucher Details
                  </span>
                  {orderData?.voucher_number ? (
                    <div>
                      <p><strong>Voucher Number:</strong> {orderData?.voucher_number}</p>
                      <p><strong>Status:</strong> {orderData?.voucher_data?.status || "N/A"}</p>
                    </div>
                  ) : (
                    <p>No voucher details available.</p>
                  )}
                </div>
              </div>

              {/* Device Details Section */}
              <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">
                    Device Details
                  </span>
                    <div>
                      <p><strong>Platform:</strong> {orderData?.platform ?? 'N/A'}</p>
                      <p><strong>POS Serial ID:</strong> {orderData?.pos_serial_id ?? 'N/A'}</p>
                    </div>
                </div>
              </div>
            </div>

            {/* Buyer and Seller Details */}
            <div className="col-lg-4">
            <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">Billing Summary</span>
                  <p><strong>Total Points:</strong> {orderData?.points || 0}</p>
                  <p><strong>Discount:</strong> {orderData?.discount || "0"}</p>
                  <p><strong>Sub Total :</strong> {orderData?.total_point || 0}</p>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">
                    Seller Details
                  </span>
                  <p><strong>Name :</strong> {orderData?.seller_first_name} {orderData?.seller_last_name}</p>
                  <p><strong>Mobile :</strong> {orderData?.seller_mobile}</p>
                  <p><strong>POS Number :</strong> {orderData?.seller_pos_number}</p>
                  <p><strong>POS Serial No. :</strong> {orderData?.seller_user_id?.pos_serial_id}</p>
                  <p><strong>Version :</strong> {orderData?.version}</p>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">
                    Buyer Details
                  </span>
                  <p><strong>Name:</strong> {orderData?.buyer_first_name} {orderData?.buyer_last_name}</p>
                  <p><strong>Mobile:</strong> {orderData?.buyer_mobile}</p>
                </div>
              </div>
              {orderData?.isDelivery === 'Y' && (
                <div className="card mb-4">
                  <div className="card-body">
                    <span className="orders_now_billing_details_heading">
                      Delivery Address
                    </span>
                    <p>Flat no. : {orderData?.delivery_address?.flat_no || `--`}</p>
                    <p>Building : {orderData?.delivery_address?.building || `--`}</p>
                    <p>Street : {orderData?.delivery_address?.street || `--`}</p>
                    <p>City : {orderData?.delivery_address?.city || `--`}</p>
                    {orderData?.delivery_address?.postalCode && (<p>Postal Code : {orderData?.delivery_address?.postalCode}</p>)}
                    
                  </div>
                </div>
              )}

              {orderData?.isDelivery === 'N' && (
                <div className="card mb-4">
                  <div className="card-body">
                    <span className="orders_now_billing_details_heading">
                      Pickup Point Address
                    </span>
                    <p>Name : {orderData?.pickupAddress?.name || `--`}</p>
                    <p>Mobile : {orderData?.pickupAddress?.mobile || `--`}</p>
                    <p>Address : {orderData?.pickupAddress?.address || `--`}</p>
                  </div>
                </div>
              )}
              
            </div>
  
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;